import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Popover from 'antd/lib/popover';
import { TutorialContainer, HighlightZone, PopoverContent, ClickBlockingFrame } from './styled';

function getScrollbarWidth() {
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";

  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = "scroll";

  // add innerdiv
  const inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
}

@inject('routingStore')
@inject('onboardingStore')
@observer
class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      elementOnPage: false,
      historyListener: null,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.relocateHighlight.bind(this), false);
    this.relocateHighlight();
    this.initializeHistoryListener();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.relocateHighlight, false);
    const {historyListener} = this.state;
    if(historyListener) {
      historyListener();
    }
  }

  handleNext(step) {
    const { onboardingStore } = this.props;
    onboardingStore.setTutorialStep(step);
  }

  initializeHistoryListener() {
    const { routingStore: { browserHistory } } = this.props;
    this.setState({
      historyListener: browserHistory.listen(location => {
        const {
          onboardingStore: { minimizeTutorial, tutorialTransitioning },
          step: { expectedLocation = '' }
        } = this.props;
        if(expectedLocation && expectedLocation !== location.pathname && !tutorialTransitioning) {
          minimizeTutorial();
        }
      })
    });
  }

  relocateHighlight() {
    const { contentTarget = 'body', delay = 0 } = this.props.step;
    const scrollbarWidth = getScrollbarWidth();
    setTimeout(()=>{
      if(document.querySelector(contentTarget)) {
        const { top, left, width, height } = document.querySelector(contentTarget).getBoundingClientRect();
        this.setState({
          top,
          left: left + (this.hasScrollBar().vertical ? scrollbarWidth/2 : 0),
          width,
          height,
          elementOnPage: true
        });
        const { onboardingStore } = this.props;
        onboardingStore.endTransition();
      } else {
        this.setState({
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          elementOnPage: false
        });
      }
    }, delay);
  };

  hasScrollBar() {
    return {
      vertical: document.body.scrollHeight > document.body.clientHeight,
      horizontal: document.body.scrollWidth > document.body.clientWidth
    }
  }

  render() {
    const { onboardingStore } = this.props;
    if(onboardingStore.nextValidTutorialStep === onboardingStore.tutorialStepIndex + 1) {
      this.handleNext(onboardingStore.nextValidTutorialStep);
    }
    const {
      content = '',
      contentSide = 'right',
      highlightArea = {},
      positionModifier = {},
    } = this.props.step;

    let { height = '', width = '' } = highlightArea;
    const { addTop = 0, addLeft = 0 } = positionModifier;
    const { top, left, elementOnPage } = this.state;

    // if height and width are not provided in the step, use the calculated one
    if (!height) {
      ({height} = this.state);
    }
    if (!width) {
      ({width} = this.state);
    }

    return (
      <TutorialContainer>
        {elementOnPage ? (
          <React.Fragment>
            <Popover
              placement={contentSide}
              title={null}
              content={<PopoverContent onClick={onboardingStore.disableTutorial} content={content} />}
              defaultVisible
              trigger='click'
              visible
              overlayClassName="tutorial-popover"
            >
              <HighlightZone height={`${height}px`} width={`${width}px`} top={`${top + addTop}px`} left={`${left + addLeft}px`} />
            </Popover>
            <ClickBlockingFrame height={height} width={width} top={top + addTop} left={left + addLeft} opacity="0.2" />
          </React.Fragment>
        ) : (
          <HighlightZone height="0px" width="0px" top="0px" left="0px" />
        )}
      </TutorialContainer>
    );
  }
}

Tooltip.propTypes = {
  step: PropTypes.object,
  onboardingStore: PropTypes.object,
  routingStore: PropTypes.object
};

export default Tooltip;
